import Api from "./Api";

export function createWorshipBibleUser(props, firstName, lastName, email, password, productName, couponCode = "") {
    const requestData = {
        firstName,
        lastName,
        email,
        password,
        privacyPolicy: true,
    };

    return Api.post(`/user/registration`, requestData)
        .then(async res => {
            sessionStorage.setItem("customer-registration", JSON.stringify(res.data));

            const subscriptionResponse = await Api.post(`/payment/create-subscription`, {
                externalCustomerId: res.data.externalCustomerId,
                productName: productName,
                plan: sessionStorage.getItem("selectedPlan"),
                currency: "gbp",
                couponCode: couponCode
            });

            return subscriptionResponse.data; // Return full response to caller
        })
        .catch(error => {
            console.error("Registration error:", error);
            let errorMessage;
            if (error.response?.status === 409 && error.response?.data?.code === "ALREADY_MEMBER") {
                errorMessage = "You are already a member of a group account and cannot purchase an individual subscription. Visit your profile to manage your group.";
            } else if (error.response?.data || error.data) {
                errorMessage = "Email address already registered, please sign in or register a different email address";
            } else {
                errorMessage = error.message || "Something went wrong! Please retry";
            }
            throw new Error(errorMessage);
        });
}

export async function createWorshipBibleTeamUser(
    props, firstName, lastName, email, password, teamName, couponCode = ""
) {
    const requestData = {
        firstName,
        lastName,
        email,
        password,
        privacyPolicy: true
    };

    try {
        const registrationRes = await Api.post(`/user/registration`, requestData);
        sessionStorage.setItem("customer-registration", JSON.stringify(registrationRes.data));

        const subscriptionRes = await Api.post(
            `/payment/create-team-registration-subscription`,
            {
                externalCustomerId: registrationRes.data.externalCustomerId,
                teamName: teamName,
                plan: "year",
                currency: "gbp",
                couponCode: couponCode,
            }
        );

        return subscriptionRes.data;
    } catch (error) {
        console.error("Team registration error:", error);
        const errorMessage = error.response?.status === 409 && error.response?.data?.code === "ALREADY_MEMBER"
            ? "You are already a member of a group account. Visit your profile to manage your group."
            : error.response?.data
            ? "Email address already registered, please sign in or register with a different email address"
            : (error.message || "Something went wrong! Please retry");
        throw new Error(errorMessage);
    }
}

export async function createWorshipBibleEnterpriseUser(
    props, firstName, lastName, email, password, orgName, couponCode = ""
) {
    const requestData = {
        firstName,
        lastName,
        email,
        password,
        privacyPolicy: true
    };

    try {
        const registrationRes = await Api.post(`/user/registration`, requestData);
        sessionStorage.setItem("customer-registration", JSON.stringify(registrationRes.data));

        const subscriptionRes = await Api.post(
            `/payment/create-enterprise-registration-subscription`,
            {
                externalCustomerId: registrationRes.data.externalCustomerId,
                orgName,
                currency: "gbp",
                couponCode,
            }
        );

        return subscriptionRes.data;
    } catch (error) {
        console.error("Organisation registration error:", error);
        const errorMessage = error.response?.status === 409 && error.response?.data?.code === "ALREADY_MEMBER"
            ? "You are already a member of a group account. Visit your profile to manage your group."
            : error.response?.data
            ? "Email address already registered, please sign in or register with a different email address"
            : (error.message || "Something went wrong! Please retry");
        throw new Error(errorMessage);
    }
}
